module.exports = __webpack_public_path__ + "img/tips_banner.af1eecdf.png";